import React, { FC, Fragment } from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'modules/Stores';
import ConvertPositionModal from 'modules/TradesPW3/Positions/components/ConvertPositionModal/ConvertPositionModal';

const ConvertPositionModalContainer: FC = () => {
  const {
    modalsConfig: { convertPosition },
  } = useStore('AppStore');
  const { convertingPositionId, getPositionByUniqueId, positions } = useStore(
    'PositionsPW3Service',
  );
  const position = getPositionByUniqueId(positions, convertingPositionId);

  return convertPosition && position ? (
    <ConvertPositionModal
      position={position}
      positionId={convertingPositionId}
    />
  ) : (
    <Fragment />
  );
};

export default observer(ConvertPositionModalContainer);
